 

<div *ngIf="!initialLoading; else loading">
 
<div *ngIf="stream?.publicIdentity">
 

<div *ngIf="stream.chatEnabled">
<div class="wrapper">
<app-watcher-chat  *ngIf="accessOk === true" [nameFromEmbed]="nameFromEmbed" [stream]="stream"></app-watcher-chat> 
</div>
<div  *ngIf="accessOk === false" class="wrapper">
	<div class="message"><p>
	
	{{ stream.publicIdentity !== '0d29511e' ?
	 'Увійдіть в трансляцію щоб бачити чат' :
	 "Enter access key on the stream watch page to see the chat" }}
	
	
	</p> <button (click)="reload()" nbButton status="primary" > {{ stream.publicIdentity !== '0d29511e' ? 'Перезавантажити' : 'Refresh' }}</button></div>

</div>

</div> 

<div class="wrapper"  *ngIf="!stream.chatEnabled">
	<div class="message"><p>{{ stream.publicIdentity !== '0d29511e' ? 'Чат вимкнено' : 'The chat is desabled' }}</p> <button (click)="reload()" nbButton status="primary" >{{ stream.publicIdentity !== '0d29511e' ? 'Перезавантажити' : 'Refresh' }}</button></div>
</div>

</div>
<div *ngIf="!stream?.publicIdentity"><h3>404 not found</h3></div>
</div>
<ng-template #loading>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;">  <app-loader></app-loader> </div>
        </div>
</ng-template>
